import React from 'react';

import { Grid, Chip } from 'e100-react-components';
import { PriceSelect } from './PriceSelect/PriceSelect';
import { SortSelect } from './SortSelect/SortSelect';

import { useFilters } from '../hooks';
import { useRouteStationServicesFilterContext } from '../context';
import { useStyles } from './styles';

export const RouteStationServicesFilter = () => {
  const filters = useFilters();
  const classes = useStyles();
  const { activeFilter, setActiveFilter } = useRouteStationServicesFilterContext();

  return (
    <div className={classes.container}>
      <Grid container wrap="nowrap">
        {filters.map(({ value, key }) => (
          <Grid item key={key}>
            <Chip
              classes={{
                root: classes.chip,
              }}
              label={value}
              clickable
              variant="outlined"
              color={activeFilter === key ? 'primary' : 'default'}
              onClick={() => {
                setActiveFilter(key);
              }}
            />
          </Grid>
        ))}
        <Grid item>
          <PriceSelect />
        </Grid>
        <Grid item>
          <SortSelect />
        </Grid>
      </Grid>
    </div>
  );
};
